/**
 * @generated SignedSource<<9a4b366c662fe746a19f6be83675f1d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getPdpEstimateSimilarSold_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"showPricingGuidance_item">;
  readonly " $fragmentType": "getPdpEstimateSimilarSold_item";
};
export type getPdpEstimateSimilarSold_item$key = {
  readonly " $data"?: getPdpEstimateSimilarSold_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"getPdpEstimateSimilarSold_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getPdpEstimateSimilarSold_item"
};

(node as any).hash = "9dc26bf37c3a0468939889ef153b1bef";

export default node;
